<div class="alert-container" [ngClass]="alertClasses()" (click)="toggleExpand()">
  <div class="alert-icon" [ngClass]="type()">
    {{ iconText() }}
  </div>

  @if (text()) {
    <div class="alert-message">{{ text() }}</div>
  }

  <div class="alert-multiline"></div>

  @if (url()) {
    <div class="alert-link">
      <a [href]="url()" target="_blank" rel="noopener noreferrer">{{ urlText() }}</a>
    </div>
  }
  @if (isExpandable()) {
    <i class="down-icon" [ngClass]="{expanded: isExpanded()}"></i>
  }

  <ng-content select=".alert-multiline"></ng-content>
</div>
@if (isExpanded() && contentTemplate()) {
  <div [ngClass]="type()" class="info-content">
    <ng-container *ngTemplateOutlet="contentTemplate()"></ng-container>
  </div>
}
